import { render, staticRenderFns } from "./WallAccommodationsBlock.vue?vue&type=template&id=b9aea404"
import script from "./WallAccommodationsBlock.vue?vue&type=script&lang=js"
export * from "./WallAccommodationsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports